import * as ActionTypes from "./ActionTypes";

export const AddPair = pairInfo => {
  return {
    type: ActionTypes.TICKET_ADD_PAIR,
    pairInfo: pairInfo
  };
};

export const RemovePair = matchID => {
  return {
    type: ActionTypes.TICKET_REMOVE_PAIR,
    matchID: matchID
  };
};

export const UpdateTicketCoefs = updatedMatches => {
  return {
    type: ActionTypes.TICKET_PAIRS_UPDATE_COEFS,
    updatedMatches: updatedMatches
  };
};

export const ChangePairCheckedState = (matchID, checked) => {
  return {
    type: ActionTypes.TICKET_CHANGE_PAIR_CHECKED_STATE,
    checked: checked,
    matchID: matchID
  };
};

export const SelectAllPairs = () => {
  return {
    type: ActionTypes.TICKET_SELECT_ALL_PAIRS
  };
};

export const DeselectAllPairs = () => {
  return {
    type: ActionTypes.TICKET_DESELECT_ALL_PAIRS
  };
};

export const RemoveAllPairs = () => {
  return {
    type: ActionTypes.TICKET_REMOVE_ALL_PAIRS
  };
};

export const RestoreTicketStateFromLocalStorage = ticketInfo => {
  return {
    type: ActionTypes.TICKET_RESTORE_STATE_FROM_LOCALSTORAGE,
    ticketInfo: ticketInfo
  };
};

export const SetBetAmount = betAmount => {
  return {
    type: ActionTypes.TICKET_SET_BET_AMOUNT,
    betAmount: betAmount
  };
};

export const SetCombinationBetAmount = (combinationID, betAmount) => {
  return {
    type: ActionTypes.TICKET_SET_COMBINATION_BET_AMOUNT,
    betAmount: betAmount,
    combinationID: combinationID
  };
};

export const TogglePairFixState = matchID => {
  return {
    type: ActionTypes.TICKET_TOGGLE_PAIR_FIX_STATE,
    matchID: matchID
  };
};

export const SetCurrentlyEditedCombinationID = combinationID => {
  return {
    type: ActionTypes.TICKET_SET_EDITED_COMBINATION_ID,
    combinationID: combinationID
  };
};

export const SetTicketType = ticketTypeID => {
  return {
    type: ActionTypes.TICKET_SET_TICKET_TYPE,
    ticketTypeID: ticketTypeID
  };
};

export const ToggleSystemActiveState = systemID => {
  return {
    type: ActionTypes.TICKET_TOGGLE_ACTIVE_SYSTEM,
    systemID: systemID
  };
};



// WEBPACK FOOTER //
// ./src/ReduxStore/Actions/TicketActions.js